import { UnitType, UnitStats, UnitCategory } from './types';

// Export UnitCategory so other files can use it
export { UnitCategory } from './types';

export const UNIT_DEFINITIONS: Record<UnitType, Omit<UnitStats, 'health'> & { maxHealth: number, name: string, description: string, trainingTime: number, category: UnitCategory, level: number }> = {
  // United States Units
  [UnitType.RIFLE_SQUAD]: {
    name: 'Rifle Squad',
    movement: 3,
    attack: 4,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 10,
    description: 'Standard infantry squad with M1 Garand rifles and BAR',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.RANGER_SQUAD]: {
    name: 'Ranger Squad',
    movement: 4,
    attack: 8,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 18,
    description: 'Elite assault troops - "Rangers lead the way!"',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 4
  },
  [UnitType.AIRBORNE_SQUAD]: {
    name: 'Airborne Squad',
    movement: 4,
    attack: 5,
    defense: 4,
    maxHealth: 18,
    range: 2,
    cost: 15,
    description: 'Paratrooper infantry with M1A1 Carbines',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.SHERMAN_SECTION]: {
    name: 'Sherman Tank',
    movement: 5,
    attack: 8,
    defense: 5,
    maxHealth: 28,
    range: 3,
    cost: 25,
    description: 'M4A3 Sherman medium tank',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.TANK_DESTROYER_SECTION]: {
    name: 'M10 Wolverine',
    movement: 5,
    attack: 12,
    defense: 3,
    maxHealth: 20,
    range: 3,
    cost: 22,
    description: 'M10 Wolverine tank destroyer',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.US_ARTILLERY_SECTION]: {
    name: 'M101 Howitzer Battery',
    movement: 2,
    attack: 9,
    defense: 2,
    maxHealth: 15,
    range: 6,
    cost: 28,
    description: '2x M101A1 105mm howitzers',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.ENGINEER_SQUAD]: {
    name: 'Engineer Squad',
    movement: 3,
    attack: 6,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 15,
    description: 'Combat engineers with demolitions',
    trainingTime: 1,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.M8_GREYHOUND]: {
    name: 'M8 Greyhound',
    movement: 8,
    attack: 2,
    defense: 2,
    maxHealth: 16,
    range: 3,
    cost: 12,
    description: 'Fast armored car for reconnaissance',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 1
  },
  
  // German Units
  [UnitType.PANZERGRENADIER_SQUAD]: {
    name: 'Panzergrenadier Squad',
    movement: 3,
    attack: 4,
    defense: 4,
    maxHealth: 20,
    range: 2,
    cost: 9,
    description: 'Mechanized infantry with MG42',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.WAFFEN_SS_SQUAD]: {
    name: 'Waffen-SS Squad',
    movement: 3,
    attack: 7,
    defense: 5,
    maxHealth: 22,
    range: 2,
    cost: 18,
    description: 'Elite infantry with StG 44 assault rifles',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 4
  },
  [UnitType.FALLSCHIRMJAGER_SQUAD]: {
    name: 'Fallschirmjäger Squad',
    movement: 3,
    attack: 5,
    defense: 6,
    maxHealth: 24,
    range: 2,
    cost: 16,
    description: 'Elite paratroopers - "Green Devils"',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.PANZER_IV_ZUG]: {
    name: 'Panzer IV',
    movement: 5,
    attack: 9,
    defense: 7,
    maxHealth: 33,
    range: 3,
    cost: 28,
    description: 'Panzer IV Ausf. H tank',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.TIGER_I_SECTION]: {
    name: 'Tiger I',
    movement: 4,
    attack: 11,
    defense: 10,
    maxHealth: 38,
    range: 3,
    cost: 35,
    description: 'Tiger I heavy tank',
    trainingTime: 3,
    category: UnitCategory.ARMOR,
    level: 3
  },
  [UnitType.STUG_III_SECTION]: {
    name: 'StuG III',
    movement: 5,
    attack: 8,
    defense: 6,
    maxHealth: 26,
    range: 3,
    cost: 20,
    description: 'StuG III assault gun',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.GER_ARTILLERY_SECTION]: {
    name: 'Pak 40 Battery',
    movement: 2,
    attack: 10,
    defense: 2,
    maxHealth: 15,
    range: 4,
    cost: 26,
    description: '2x 7.5cm Pak 40 anti-tank guns',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.PIONEER_SQUAD]: {
    name: 'Pioneer Squad',
    movement: 3,
    attack: 6,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 14,
    description: 'Combat engineers with flamethrower',
    trainingTime: 1,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.SDKFZ_222]: {
    name: 'Sd.Kfz. 222',
    movement: 7,
    attack: 3,
    defense: 2,
    maxHealth: 18,
    range: 3,
    cost: 13,
    description: 'Armored car with 20mm autocannon',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 1
  },

  // German Units (Stalingrad - Eastern Wehrmacht 1942)
  [UnitType.GRENADIER_SQUAD_1942]: {
    name: 'Grenadier Squad',
    movement: 3,
    attack: 4,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 8,
    description: 'Standard Wehrmacht infantry with Kar 98k rifles and MG34',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.STURM_ABTEILUNG_SQUAD]: {
    name: 'Sturm-Abteilung Squad',
    movement: 3,
    attack: 6,
    defense: 5,
    maxHealth: 22,
    range: 1,
    cost: 17,
    description: 'Elite assault troops with MP 40 submachine guns and grenades',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 4
  },
  [UnitType.FALLSCHIRMJAGER_SQUAD_1942]: {
    name: 'Fallschirmjäger Squad',
    movement: 3,
    attack: 5,
    defense: 6,
    maxHealth: 24,
    range: 2,
    cost: 16,
    description: 'Elite paratroopers - "Green Devils"',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.PANZERGRENADIER_SQUAD_1942]: {
    name: 'Panzergrenadier Squad',
    movement: 3,
    attack: 5,
    defense: 4,
    maxHealth: 22,
    range: 2,
    cost: 15,
    description: 'Early mechanized infantry with improved equipment',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.STURMPIONIERE]: {
    name: 'Sturmpioniere',
    movement: 3,
    attack: 6,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 14,
    description: 'Combat engineers with flamethrowers and demolition charges',
    trainingTime: 1,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.SANITATER_SQUAD_1942]: {
    name: 'Sanitäter Squad',
    movement: 3,
    attack: 2,
    defense: 4,
    maxHealth: 18,
    range: 1,
    cost: 12,
    description: 'Wehrmacht medical corps with field dressings',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.PANZER_IV_AUSF_F2]: {
    name: 'Panzer IV Ausf. F2',
    movement: 4,
    attack: 9,
    defense: 6,
    maxHealth: 30,
    range: 3,
    cost: 25,
    description: 'Early long-gun Panzer IV with 75mm L/43 gun',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.PANZER_III_AUSF_L]: {
    name: 'Panzer III Ausf. L',
    movement: 5,
    attack: 7,
    defense: 6,
    maxHealth: 28,
    range: 2,
    cost: 22,
    description: 'Improved medium tank with 50mm L/60 gun',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.STUG_III_AUSF_F]: {
    name: 'StuG III Ausf. F',
    movement: 4,
    attack: 8,
    defense: 6,
    maxHealth: 25,
    range: 3,
    cost: 19,
    description: 'Assault gun with 75mm StuK 40 L/43 gun',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.PAK_38_BATTERY]: {
    name: 'Pak 38 Battery',
    movement: 3,
    attack: 8,
    defense: 2,
    maxHealth: 15,
    range: 4,
    cost: 20,
    description: '50mm Pak 38 anti-tank guns',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.SDKFZ_250_1]: {
    name: 'Sd.Kfz. 250/1',
    movement: 6,
    attack: 3,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 12,
    description: 'Light armored halftrack with MG34',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 1
  },
  [UnitType.JU_87_D_STUKA]: {
    name: 'Ju 87 B Stuka',
    movement: 6,
    attack: 7,
    defense: 3,
    maxHealth: 20,
    range: 1,
    cost: 28,
    description: 'Standard dive bomber with bombs and machine guns',
    trainingTime: 3,
    category: UnitCategory.AIRCRAFT,
    level: 3
  },
  [UnitType.HE_111_H6]: {
    name: 'He 111 H-6',
    movement: 6,
    attack: 8,
    defense: 5,
    maxHealth: 26,
    range: 2,
    cost: 35,
    description: 'Medium bomber with defensive armament',
    trainingTime: 3,
    category: UnitCategory.AIRCRAFT,
    level: 3
  },
  [UnitType.OPEL_BLITZ_1942]: {
    name: 'Opel Blitz 3-ton',
    movement: 6,
    attack: 0,
    defense: 1,
    maxHealth: 12,
    range: 0,
    cost: 6,
    description: 'Standard Wehrmacht 3-ton truck',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.SDKFZ_251_1942]: {
    name: 'Sd.Kfz. 251',
    movement: 5,
    attack: 3,
    defense: 3,
    maxHealth: 19,
    range: 2,
    cost: 14,
    description: 'Hanomag halftrack with MG42',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  },
  
  // UK Units (Tunisia)
  [UnitType.INFANTRY_SECTION]: {
    name: 'Infantry Section',
    movement: 3,
    attack: 4,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 10,
    description: 'British infantry section with Lee-Enfield rifles and Bren gun',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.GUARDS_INFANTRY]: {
    name: 'Guards Infantry',
    movement: 3,
    attack: 7,
    defense: 4,
    maxHealth: 22,
    range: 2,
    cost: 17,
    description: 'Elite Guards regiments - "Nulli Secundus"',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 4
  },
  [UnitType.COMMANDO_SECTION]: {
    name: 'Commando Section',
    movement: 4,
    attack: 6,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 16,
    description: 'Royal Marine and Army Commandos - specialists in raids',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.SAPPER_SECTION]: {
    name: 'Sapper Section',
    movement: 3,
    attack: 5,
    defense: 3,
    maxHealth: 20,
    range: 1,
    cost: 14,
    description: 'Royal Engineers - "Ubique" (Everywhere)',
    trainingTime: 1,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.CRUSADER_TANK]: {
    name: 'Crusader Tank',
    movement: 6,
    attack: 7,
    defense: 6,
    maxHealth: 24,
    range: 3,
    cost: 22,
    description: 'Crusader Mk III cruiser tank - fast but lightly armored',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.MATILDA_II]: {
    name: 'Matilda II',
    movement: 4,
    attack: 6,
    defense: 8,
    maxHealth: 32,
    range: 2,
    cost: 26,
    description: '"Queen of the Desert" - heavily armored infantry tank',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.SIX_POUNDER_AT]: {
    name: '6-Pounder AT Gun',
    movement: 2,
    attack: 10,
    defense: 2,
    maxHealth: 15,
    range: 4,
    cost: 18,
    description: '57mm anti-tank gun - effective against most armor',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.TWENTY_FIVE_POUNDER]: {
    name: '25-Pounder Battery',
    movement: 2,
    attack: 8,
    defense: 2,
    maxHealth: 16,
    range: 5,
    cost: 20,
    description: 'Versatile gun-howitzer - backbone of Commonwealth artillery',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 2
  },
  [UnitType.DAIMLER_DINGO]: {
    name: 'Daimler Dingo',
    movement: 8,
    attack: 2,
    defense: 4,
    maxHealth: 18,
    range: 5,
    cost: 13,
    description: 'Scout car with excellent protection and spotting',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 1
  },
  
  // Afrika Korps Units (Tunisia)
  [UnitType.SCHUTZEN_SQUAD]: {
    name: 'Schützen Squad',
    movement: 3,
    attack: 4,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 9,
    description: 'Afrika Korps infantry with Kar 98k rifles and MG 34',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.AFRIKA_GRENADIERS]: {
    name: 'Afrika Grenadiers',
    movement: 3,
    attack: 6,
    defense: 5,
    maxHealth: 22,
    range: 2,
    cost: 16,
    description: 'Desert veterans with years of experience',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.AK_PIONEER_SQUAD]: {
    name: 'Pioneer Squad',
    movement: 3,
    attack: 5,
    defense: 3,
    maxHealth: 20,
    range: 1,
    cost: 15,
    description: 'Afrika Korps engineers - mine laying and clearing specialists',
    trainingTime: 1,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.AK_FALLSCHIRMJAGER]: {
    name: 'Fallschirmjäger',
    movement: 3,
    attack: 7,
    defense: 4,
    maxHealth: 24,
    range: 2,
    cost: 18,
    description: 'Elite paratroopers - Ramcke Brigade',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 4
  },
  [UnitType.PANZER_III]: {
    name: 'Panzer III',
    movement: 5,
    attack: 7,
    defense: 7,
    maxHealth: 26,
    range: 3,
    cost: 24,
    description: 'Panzer III Ausf. L - workhorse of the Afrika Korps',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.PANZER_II]: {
    name: 'Panzer II',
    movement: 6,
    attack: 5,
    defense: 5,
    maxHealth: 20,
    range: 2,
    cost: 18,
    description: 'Light reconnaissance tank with 20mm autocannon',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.EIGHTY_EIGHT_FLAK]: {
    name: '88mm Flak',
    movement: 2,
    attack: 12,
    defense: 2,
    maxHealth: 18,
    range: 5,
    cost: 25,
    description: 'Legendary "Acht-acht" - devastating against tanks',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 2
  },
  [UnitType.PAK_38]: {
    name: 'Pak 38',
    movement: 2,
    attack: 9,
    defense: 2,
    maxHealth: 15,
    range: 4,
    cost: 20,
    description: '50mm anti-tank gun - standard AT weapon',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.SDKFZ_250_9]: {
    name: 'Sd.Kfz. 250/9',
    movement: 7,
    attack: 3,
    defense: 2,
    maxHealth: 18,
    range: 3,
    cost: 12,
    description: 'Reconnaissance halftrack',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 1
  },
  
  // Soviet Units (Stalingrad)
  [UnitType.CONSCRIPT_SQUAD]: {
    name: 'Conscript Squad',
    movement: 3,
    attack: 2,
    defense: 2,
    maxHealth: 16,
    range: 2,
    cost: 6,
    description: 'Poorly trained conscripts - "Not one step back!"',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.RED_ARMY_SQUAD]: {
    name: 'Red Army Squad',
    movement: 3,
    attack: 3,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 9,
    description: 'Standard rifle squad with Mosin-Nagant rifles',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.SHOCK_TROOPS]: {
    name: 'Shock Troops',
    movement: 3,
    attack: 6,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 12,
    description: 'Urban assault specialists with grenades and SMGs',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 4
  },
  [UnitType.T70_LIGHT_TANK]: {
    name: 'T-70 Light Tank',
    movement: 6,
    attack: 4,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 12,
    description: 'Fast light tank for reconnaissance',
    trainingTime: 1,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.T34_76]: {
    name: 'T-34/76',
    movement: 5,
    attack: 6,
    defense: 5,
    maxHealth: 24,
    range: 3,
    cost: 18,
    description: 'Legendary medium tank - backbone of Soviet armor',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.KV1_HEAVY_TANK]: {
    name: 'KV-1',
    movement: 4,
    attack: 7,
    defense: 8,
    maxHealth: 30,
    range: 3,
    cost: 24,
    description: 'Heavy tank with thick armor but prone to breakdowns',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 3
  },
  [UnitType.BA64_ARMORED_CAR]: {
    name: 'BA-64',
    movement: 8,
    attack: 2,
    defense: 1,
    maxHealth: 14,
    range: 2,
    cost: 8,
    description: 'Light armored car for scouting',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 1
  },
  [UnitType.ZIS3_AT_GUN]: {
    name: 'ZiS-3 Field Gun',
    movement: 2,
    attack: 8,
    defense: 2,
    maxHealth: 14,
    range: 4,
    cost: 18,
    description: '76mm divisional gun - versatile anti-tank/artillery',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.KATYUSHA_BATTERY]: {
    name: 'Katyusha Battery',
    movement: 5,
    attack: 10,
    defense: 1,
    maxHealth: 12,
    range: 5,
    cost: 16,
    description: '"Stalin\'s Organ" - devastating rocket artillery',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 2
  },
  [UnitType.SOVIET_SAPPER_SQUAD]: {
    name: 'Sapper Squad',
    movement: 3,
    attack: 4,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 12,
    description: 'Combat engineers with mines and explosives',
    trainingTime: 1,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  
  // US Marine Units (Okinawa)
  [UnitType.MARINE_SQUAD]: {
    name: 'Marine Squad',
    movement: 3,
    attack: 5,
    defense: 3,
    maxHealth: 22,
    range: 2,
    cost: 11,
    description: 'Marine rifle squad with emphasis on firepower',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.MARINE_RAIDERS]: {
    name: 'Marine Raiders',
    movement: 4,
    attack: 7,
    defense: 4,
    maxHealth: 20,
    range: 2,
    cost: 18,
    description: 'Elite Marine Raiders - "Gung Ho!" spirit',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 4
  },
  [UnitType.MARINE_FLAME_TEAM]: {
    name: 'Marine Flame Team',
    movement: 3,
    attack: 8,
    defense: 2,
    maxHealth: 18,
    range: 1,
    cost: 16,
    description: 'Specialized assault team for bunker clearing',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.MARINE_ENGINEERS]: {
    name: 'Marine Engineers',
    movement: 3,
    attack: 6,
    defense: 4,
    maxHealth: 20,
    range: 1,
    cost: 13,
    description: 'Combat engineers with demolition equipment',
    trainingTime: 1,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.M4A3_SHERMAN]: {
    name: 'M4A3 Sherman',
    movement: 5,
    attack: 8,
    defense: 5,
    maxHealth: 28,
    range: 2,
    cost: 25,
    description: 'Standard Marine tank for island warfare',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.M3_STUART]: {
    name: 'M3 Stuart',
    movement: 6,
    attack: 6,
    defense: 3,
    maxHealth: 22,
    range: 2,
    cost: 20,
    description: 'Fast reconnaissance tank',
    trainingTime: 2,
    category: UnitCategory.RECONNAISSANCE,
    level: 1
  },
  [UnitType.M7_PRIEST]: {
    name: 'M7 Priest',
    movement: 5,
    attack: 9,
    defense: 2,
    maxHealth: 16,
    range: 5,
    cost: 22,
    description: 'Self-propelled artillery support',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 2
  },
  [UnitType.PACK_HOWITZER]: {
    name: 'Pack Howitzer',
    movement: 2,
    attack: 7,
    defense: 2,
    maxHealth: 15,
    range: 4,
    cost: 18,
    description: 'Lightweight artillery for difficult terrain',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  
  // Imperial Japan Units (Okinawa)
  [UnitType.IJA_SQUAD]: {
    name: 'IJA Squad',
    movement: 4,
    attack: 4,
    defense: 4,
    maxHealth: 20,
    range: 2,
    cost: 7,
    description: 'Standard Japanese infantry - no retreat',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.SNLF_SQUAD]: {
    name: 'SNLF Squad',
    movement: 4,
    attack: 5,
    defense: 5,
    maxHealth: 22,
    range: 2,
    cost: 12,
    description: 'Special Naval Landing Force - elite naval infantry',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.ASSAULT_PIONEERS]: {
    name: 'Assault Pioneers',
    movement: 3,
    attack: 6,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 11,
    description: 'Specialized assault troops for close combat',
    trainingTime: 2,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.CAVE_DEFENSE_SQUAD]: {
    name: 'Cave Defense Squad',
    movement: 3,
    attack: 5,
    defense: 6,
    maxHealth: 24,
    range: 1,
    cost: 13,
    description: 'Specialists in tunnel and cave warfare',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 4
  },
  [UnitType.TYPE_95_HA_GO]: {
    name: 'Type 95 Ha-Go',
    movement: 6,
    attack: 4,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 12,
    description: 'Light tank used for reconnaissance and infantry support',
    trainingTime: 1,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.TYPE_97_CHI_HA]: {
    name: 'Type 97 Chi-Ha',
    movement: 5,
    attack: 6,
    defense: 4,
    maxHealth: 24,
    range: 2,
    cost: 16,
    description: 'Standard Japanese medium tank',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.TYPE_4_CHI_TO]: {
    name: 'Type 4 Chi-To',
    movement: 4,
    attack: 8,
    defense: 6,
    maxHealth: 30,
    range: 3,
    cost: 28,
    description: 'Experimental heavy tank - Japan\'s answer to Allied armor',
    trainingTime: 3,
    category: UnitCategory.ARMOR,
    level: 3
  },
  [UnitType.TYPE_92_JYU_SOKOSHA]: {
    name: 'Type 92 Jyu-Sokosha',
    movement: 7,
    attack: 2,
    defense: 2,
    maxHealth: 16,
    range: 3,
    cost: 10,
    description: 'Armored car for reconnaissance and patrol duties',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 1
  },
  [UnitType.TYPE_92_BATTALION_GUN]: {
    name: 'Type 92 Battalion Gun',
    movement: 2,
    attack: 8,
    defense: 3,
    maxHealth: 16,
    range: 4,
    cost: 15,
    description: 'Versatile infantry gun for direct support',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 2
  },
  [UnitType.TYPE_89_MORTAR]: {
    name: 'Type 89 Mortar',
    movement: 4,
    attack: 7,
    defense: 3,
    maxHealth: 15,
    range: 3,
    cost: 12,
    description: 'Heavy grenade discharger "knee mortar"',
    trainingTime: 1,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.TYPE_1_47MM_AT_GUN]: {
    name: 'Type 1 47mm AT Gun',
    movement: 2,
    attack: 9,
    defense: 2,
    maxHealth: 14,
    range: 3,
    cost: 14,
    description: 'Japan\'s best AT gun in 1945',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 3
  },
  [UnitType.TYPE_96_150MM_HOWITZER]: {
    name: 'Type 96 150mm Howitzer',
    movement: 2,
    attack: 10,
    defense: 2,
    maxHealth: 18,
    range: 6,
    cost: 24,
    description: 'Heavy howitzer for long-range bombardment',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 4
  },
  
  // Aircraft Units
  // US Aircraft
  [UnitType.P51_MUSTANG]: {
    name: 'P-51 Mustang',
    movement: 8,
    attack: 4,
    defense: 3,
    maxHealth: 16,
    range: 2,
    cost: 28,
    description: 'Long-range fighter with excellent maneuverability',
    trainingTime: 3,
    category: UnitCategory.FIGHTERS,
    level: 2
  },
  [UnitType.B24_LIBERATOR]: {
    name: 'B-24 Liberator',
    movement: 6,
    attack: 8,
    defense: 5,
    maxHealth: 24,
    range: 1,
    cost: 35,
    description: 'Heavy bomber for strategic bombing missions',
    trainingTime: 3,
    category: UnitCategory.BOMBERS,
    level: 3
  },
  
  // German Aircraft
  [UnitType.BF109_FIGHTER]: {
    name: 'Bf 109 Fighter',
    movement: 8,
    attack: 5,
    defense: 4,
    maxHealth: 18,
    range: 2,
    cost: 32,
    description: 'Germany\'s primary fighter aircraft',
    trainingTime: 3,
    category: UnitCategory.FIGHTERS,
    level: 2
  },
  [UnitType.JU88_BOMBER]: {
    name: 'Ju 88 Bomber',
    movement: 6,
    attack: 9,
    defense: 6,
    maxHealth: 28,
    range: 1,
    cost: 38,
    description: 'Multi-role bomber and night fighter',
    trainingTime: 3,
    category: UnitCategory.BOMBERS,
    level: 3
  },
  
  // British Aircraft
  [UnitType.SPITFIRE_MK_V]: {
    name: 'Spitfire Mk V',
    movement: 8,
    attack: 4,
    defense: 3,
    maxHealth: 16,
    range: 2,
    cost: 26,
    description: 'Iconic British fighter aircraft',
    trainingTime: 3,
    category: UnitCategory.FIGHTERS,
    level: 2
  },
  [UnitType.LANCASTER_BOMBER]: {
    name: 'Lancaster Bomber',
    movement: 6,
    attack: 8,
    defense: 5,
    maxHealth: 24,
    range: 1,
    cost: 34,
    description: 'Heavy bomber for strategic bombing',
    trainingTime: 3,
    category: UnitCategory.BOMBERS,
    level: 3
  },
  
  // Soviet Aircraft
  [UnitType.YAK_3_FIGHTER]: {
    name: 'Yak-3 Fighter',
    movement: 8,
    attack: 3,
    defense: 2,
    maxHealth: 14,
    range: 2,
    cost: 22,
    description: 'Fast and maneuverable Soviet fighter',
    trainingTime: 3,
    category: UnitCategory.FIGHTERS,
    level: 2
  },
  [UnitType.IL2_STURMOVIK]: {
    name: 'Il-2 Sturmovik',
    movement: 6,
    attack: 7,
    defense: 4,
    maxHealth: 20,
    range: 1,
    cost: 28,
    description: 'Heavily armored ground-attack aircraft',
    trainingTime: 3,
    category: UnitCategory.BOMBERS,
    level: 3
  },
  
  // Japanese Aircraft
  [UnitType.A6M_ZERO]: {
    name: 'A6M Zero',
    movement: 8,
    attack: 4,
    defense: 2,
    maxHealth: 14,
    range: 2,
    cost: 24,
    description: 'Highly maneuverable carrier-based fighter',
    trainingTime: 3,
    category: UnitCategory.FIGHTERS,
    level: 2
  },
  [UnitType.G4M_BETTY]: {
    name: 'G4M Betty',
    movement: 6,
    attack: 7,
    defense: 4,
    maxHealth: 20,
    range: 1,
    cost: 29,
    description: 'Long-range bomber with torpedo capability',
    trainingTime: 3,
    category: UnitCategory.BOMBERS,
    level: 3
  },
  
  // Canadian Units (Campobasso)
  [UnitType.CANADIAN_INFANTRY_SECTION]: {
    name: 'Infantry Section',
    movement: 3,
    attack: 5,
    defense: 3,
    maxHealth: 22,
    range: 2,
    cost: 10,
    description: 'Standard Canadian rifle section with Lee-Enfield rifles',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.PPCLI]: {
    name: "Princess Patricia's Light Infantry",
    movement: 4,
    attack: 8,
    defense: 4,
    maxHealth: 24,
    range: 2,
    cost: 18,
    description: 'Elite Canadian light infantry regiment',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 4
  },
  [UnitType.HIGHLAND_REGIMENT]: {
    name: 'Highland Regiment',
    movement: 3,
    attack: 6,
    defense: 5,
    maxHealth: 26,
    range: 2,
    cost: 16,
    description: 'Tough Scottish-Canadian infantry with bagpipes',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.COMBAT_ENGINEERS]: {
    name: 'Combat Engineers',
    movement: 3,
    attack: 6,
    defense: 3,
    maxHealth: 20,
    range: 1,
    cost: 15,
    description: 'Royal Canadian Engineers with demolition expertise',
    trainingTime: 1,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.RAM_TANK]: {
    name: 'Ram Tank',
    movement: 5,
    attack: 7,
    defense: 6,
    maxHealth: 30,
    range: 3,
    cost: 24,
    description: 'Canadian-built cruiser tank',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.GRIZZLY_CRUISER]: {
    name: 'Grizzly I Cruiser',
    movement: 5,
    attack: 8,
    defense: 5,
    maxHealth: 28,
    range: 3,
    cost: 28,
    description: 'Canadian-built M4A1 Sherman variant',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.SEXTON_SPG]: {
    name: 'Sexton SPG',
    movement: 5,
    attack: 9,
    defense: 3,
    maxHealth: 22,
    range: 5,
    cost: 22,
    description: 'Self-propelled 25-pounder gun',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 2
  },
  [UnitType.TWENTY_FIVE_POUNDER_BATTERY]: {
    name: '25-pounder Battery',
    movement: 2,
    attack: 8,
    defense: 2,
    maxHealth: 18,
    range: 6,
    cost: 20,
    description: 'Standard Commonwealth field artillery',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.RECONNAISSANCE_PATROL]: {
    name: 'Reconnaissance Patrol',
    movement: 7,
    attack: 3,
    defense: 2,
    maxHealth: 15,
    range: 2,
    cost: 12,
    description: 'Universal Carrier with scouts and extended vision',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 1
  },
  [UnitType.SHERMAN_FIREFLY]: {
    name: 'Sherman Firefly',
    movement: 5,
    attack: 11,
    defense: 5,
    maxHealth: 28,
    range: 4,
    cost: 32,
    description: 'Sherman with powerful 17-pounder gun',
    trainingTime: 3,
    category: UnitCategory.ARMOR,
    level: 3
  },
  [UnitType.SPITFIRE_FIGHTER]: {
    name: 'Spitfire Fighter',
    movement: 8,
    attack: 10,
    defense: 2,
    maxHealth: 15,
    range: 4,
    cost: 30,
    description: 'Canadian-piloted Spitfire squadron',
    trainingTime: 3,
    category: UnitCategory.FIGHTERS,
    level: 2
  },
  [UnitType.MOSQUITO_FIGHTER_BOMBER]: {
    name: 'Mosquito Fighter-Bomber',
    movement: 7,
    attack: 12,
    defense: 3,
    maxHealth: 18,
    range: 5,
    cost: 35,
    description: 'Versatile wooden fighter-bomber',
    trainingTime: 3,
    category: UnitCategory.BOMBERS,
    level: 3
  },
  
  // Italian Units (Campobasso)
  [UnitType.BERSAGLIERI_SQUAD]: {
    name: 'Bersaglieri Squad',
    movement: 3,
    attack: 4,
    defense: 4,
    maxHealth: 20,
    range: 2,
    cost: 9,
    description: 'Elite Italian light infantry with plumed helmets',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.ALPINI_MOUNTAIN_TROOPS]: {
    name: 'Alpini Mountain Troops',
    movement: 3,
    attack: 6,
    defense: 6,
    maxHealth: 24,
    range: 2,
    cost: 17,
    description: 'Expert mountain warfare specialists',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.FOLGORE_PARATROOPERS]: {
    name: 'Folgore Paratroopers',
    movement: 4,
    attack: 7,
    defense: 4,
    maxHealth: 22,
    range: 2,
    cost: 16,
    description: 'Elite paratrooper regiment - "Thunderbolt" division',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 4
  },
  [UnitType.GENIO_ENGINEERS]: {
    name: 'Genio Engineers',
    movement: 3,
    attack: 5,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 14,
    description: 'Italian combat engineers with mine expertise',
    trainingTime: 1,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.M15_42_TANK]: {
    name: 'M15/42 Tank',
    movement: 5,
    attack: 6,
    defense: 5,
    maxHealth: 26,
    range: 3,
    cost: 22,
    description: 'Standard Italian medium tank',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.SEMOVENTE_75_18]: {
    name: 'Semovente 75/18',
    movement: 5,
    attack: 8,
    defense: 4,
    maxHealth: 24,
    range: 3,
    cost: 20,
    description: 'Self-propelled assault gun',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.CANNONE_75_32]: {
    name: 'Cannone 75/32',
    movement: 2,
    attack: 7,
    defense: 2,
    maxHealth: 16,
    range: 5,
    cost: 18,
    description: 'Effective field artillery piece',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.OBICE_149_19]: {
    name: '149mm Howitzer Battery',
    movement: 2,
    attack: 10,
    defense: 2,
    maxHealth: 20,
    range: 7,
    cost: 26,
    description: 'Heavy field howitzer for long-range bombardment',
    trainingTime: 3,
    category: UnitCategory.ARTILLERY,
    level: 2
  },
  [UnitType.ARDITI_SCOUTS]: {
    name: 'Arditi Scouts',
    movement: 7,
    attack: 4,
    defense: 2,
    maxHealth: 16,
    range: 2,
    cost: 13,
    description: 'Lancia 1ZM armored car with elite scouts',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 1
  },
  [UnitType.P26_40_HEAVY_TANK]: {
    name: 'P26/40 Heavy Tank',
    movement: 4,
    attack: 9,
    defense: 7,
    maxHealth: 32,
    range: 3,
    cost: 30,
    description: "Italy's heaviest tank design",
    trainingTime: 3,
    category: UnitCategory.ARMOR,
    level: 3
  },
  [UnitType.MACCHI_C205]: {
    name: 'Macchi C.205',
    movement: 8,
    attack: 9,
    defense: 3,
    maxHealth: 16,
    range: 4,
    cost: 28,
    description: "Italy's best fighter aircraft",
    trainingTime: 3,
    category: UnitCategory.FIGHTERS,
    level: 2
  },
  [UnitType.SM79_BOMBER]: {
    name: 'SM.79 Bomber',
    movement: 6,
    attack: 11,
    defense: 2,
    maxHealth: 20,
    range: 5,
    cost: 34,
    description: 'Tri-motor torpedo bomber "Sparviero"',
    trainingTime: 3,
    category: UnitCategory.BOMBERS,
    level: 3
  },
  
  // New Airborne Units for factions without them
  [UnitType.RED_DEVILS_PARACHUTE]: {
    name: 'Red Devils Parachute Regiment',
    movement: 4,
    attack: 5,
    defense: 4,
    maxHealth: 20,
    range: 2,
    cost: 15,
    description: '1st Airborne Division - "Red Devils" earned at Arnhem',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.VDV_GUARDS_AIRBORNE]: {
    name: 'VDV Guards Airborne',
    movement: 3,
    attack: 5,
    defense: 4,
    maxHealth: 20,
    range: 2,
    cost: 14,
    description: 'Elite Guards airborne troops - "Nobody but us!"',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.CANADIAN_PARACHUTE_BATTALION]: {
    name: 'Canadian Parachute Battalion',
    movement: 4,
    attack: 6,
    defense: 4,
    maxHealth: 20,
    range: 2,
    cost: 16,
    description: 'Elite paratroopers - first into Normandy on D-Day',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.MARINE_PARACHUTE_REGIMENT]: {
    name: 'Marine Parachute Regiment',
    movement: 4,
    attack: 6,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 16,
    description: 'Paramarine units - specialized in island assault drops',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.TEISHIN_SHUDAN]: {
    name: 'Teishin Shudan',
    movement: 3,
    attack: 5,
    defense: 5,
    maxHealth: 22,
    range: 2,
    cost: 14,
    description: 'Imperial Japanese Army paratroopers - "Giretsu" special attack units',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  
  // New Unique Elite Units for factions with airborne
  [UnitType.HEAVY_WEAPONS_SQUAD]: {
    name: 'Heavy Weapons Squad',
    movement: 3,
    attack: 7,
    defense: 4,
    maxHealth: 20,
    range: 2,
    cost: 16,
    description: 'Infantry squad with .30 cal machine guns and bazookas',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.GEBIRGSJAGER_SQUAD]: {
    name: 'Gebirgsjäger Squad',
    movement: 3,
    attack: 6,
    defense: 5,
    maxHealth: 24,
    range: 2,
    cost: 16,
    description: 'Elite mountain infantry - Edelweiss division specialists',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.BRANDENBURG_COMMANDOS]: {
    name: 'Brandenburg Commandos',
    movement: 4,
    attack: 6,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 16,
    description: 'Special forces trained in infiltration and sabotage',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.SAN_MARCO_MARINES]: {
    name: 'San Marco Marines',
    movement: 4,
    attack: 5,
    defense: 5,
    maxHealth: 22,
    range: 2,
    cost: 14,
    description: 'Elite naval infantry regiment - "Leoni di Mare" (Sea Lions)',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  
  // Medic Units
  [UnitType.MEDICAL_CORPS_SQUAD]: {
    name: 'Medical Corps Squad',
    movement: 3,
    attack: 2,
    defense: 3,
    maxHealth: 16,
    range: 1,
    cost: 14,
    description: 'Combat medics with stretchers and morphine',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.NAVY_CORPSMEN]: {
    name: 'Navy Corpsmen',
    movement: 3,
    attack: 2,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 14,
    description: 'Navy medical personnel - "Doc" to the Marines',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.FIELD_AMBULANCE_SECTION]: {
    name: 'Field Ambulance Section',
    movement: 3,
    attack: 2,
    defense: 3,
    maxHealth: 16,
    range: 1,
    cost: 13,
    description: 'RAMC field medics with medical supplies',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.MEDICAL_BATTALION]: {
    name: 'Medical Battalion',
    movement: 3,
    attack: 1,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 10,
    description: 'Combat medics and nurses - many are women',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.SANITATER_SQUAD]: {
    name: 'Sanitäter Squad',
    movement: 3,
    attack: 2,
    defense: 4,
    maxHealth: 18,
    range: 1,
    cost: 13,
    description: 'Wehrmacht medical corps with field dressings',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.AK_SANITATER]: {
    name: 'Afrika Korps Sanitäter',
    movement: 3,
    attack: 2,
    defense: 3,
    maxHealth: 16,
    range: 1,
    cost: 12,
    description: 'Desert-trained medical personnel',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.MEDICAL_SERVICE_CORPS]: {
    name: 'Medical Service Corps',
    movement: 3,
    attack: 2,
    defense: 4,
    maxHealth: 18,
    range: 1,
    cost: 14,
    description: 'RCAMC field medics - well-equipped and trained',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.SANITA_MILITARE]: {
    name: 'Sanità Militare',
    movement: 3,
    attack: 2,
    defense: 3,
    maxHealth: 16,
    range: 1,
    cost: 12,
    description: 'Military medical corps with field hospitals',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.IJA_MEDICAL_CORPS]: {
    name: 'Medical Corps Unit',
    movement: 3,
    attack: 1,
    defense: 3,
    maxHealth: 16,
    range: 1,
    cost: 10,
    description: 'Field medics - limited supplies but dedicated',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  
  // Transport Aircraft
  [UnitType.C47_SKYTRAIN]: {
    name: 'C-47 Skytrain',
    movement: 10,
    attack: 0,
    defense: 2,
    maxHealth: 20,
    range: 0,
    cost: 0,
    description: 'Douglas C-47 transport - workhorse of Allied airborne ops',
    trainingTime: 2,
    category: UnitCategory.TRANSPORT_AIRCRAFT,
    level: 1
  },
  [UnitType.R4D_SKYTRAIN]: {
    name: 'R4D Skytrain',
    movement: 10,
    attack: 0,
    defense: 2,
    maxHealth: 20,
    range: 0,
    cost: 0,
    description: 'Naval designation C-47 - Marine paratrooper transport',
    trainingTime: 2,
    category: UnitCategory.TRANSPORT_AIRCRAFT,
    level: 1
  },
  [UnitType.STIRLING_TRANSPORT]: {
    name: 'Stirling Transport',
    movement: 10,
    attack: 0,
    defense: 3,
    maxHealth: 22,
    range: 0,
    cost: 0,
    description: 'Short Stirling bomber converted for paratrooper drops',
    trainingTime: 2,
    category: UnitCategory.TRANSPORT_AIRCRAFT,
    level: 1
  },
  [UnitType.LI2_TRANSPORT]: {
    name: 'Li-2 Transport',
    movement: 9,
    attack: 0,
    defense: 2,
    maxHealth: 18,
    range: 0,
    cost: 0,
    description: 'Soviet-built DC-3 - VDV airborne transport',
    trainingTime: 2,
    category: UnitCategory.TRANSPORT_AIRCRAFT,
    level: 1
  },
  [UnitType.JU52_TRANSPORT]: {
    name: 'Ju 52 Transport',
    movement: 9,
    attack: 0,
    defense: 3,
    maxHealth: 24,
    range: 0,
    cost: 0,
    description: '"Tante Ju" - three-engine Fallschirmjäger transport',
    trainingTime: 2,
    category: UnitCategory.TRANSPORT_AIRCRAFT,
    level: 1
  },
  [UnitType.JU52_AFRIKA]: {
    name: 'Ju 52 Afrika',
    movement: 9,
    attack: 0,
    defense: 2,
    maxHealth: 22,
    range: 0,
    cost: 0,
    description: 'Desert-camouflaged Ju 52 for Afrika drops',
    trainingTime: 2,
    category: UnitCategory.TRANSPORT_AIRCRAFT,
    level: 1
  },
  [UnitType.DAKOTA_TRANSPORT]: {
    name: 'Dakota Transport',
    movement: 10,
    attack: 0,
    defense: 2,
    maxHealth: 20,
    range: 0,
    cost: 0,
    description: 'RCAF Dakota - Canadian C-47 variant',
    trainingTime: 2,
    category: UnitCategory.TRANSPORT_AIRCRAFT,
    level: 1
  },
  [UnitType.SM82_MARSUPIALE]: {
    name: 'SM.82 Marsupiale',
    movement: 8,
    attack: 0,
    defense: 3,
    maxHealth: 24,
    range: 0,
    cost: 0,
    description: 'Three-engine transport - "Marsupial" carries Folgore',
    trainingTime: 2,
    category: UnitCategory.TRANSPORT_AIRCRAFT,
    level: 1
  },
  [UnitType.KI57_TRANSPORT]: {
    name: 'Ki-57 Transport',
    movement: 9,
    attack: 0,
    defense: 2,
    maxHealth: 18,
    range: 0,
    cost: 0,
    description: 'Type 100 transport - carries Teishin paratroopers',
    trainingTime: 2,
    category: UnitCategory.TRANSPORT_AIRCRAFT,
    level: 1
  },
  
  // Ground Transport Vehicles - US
  [UnitType.GMC_CCKW]: {
    name: 'GMC CCKW',
    movement: 6,
    attack: 0,
    defense: 1,
    maxHealth: 12,
    range: 0,
    cost: 7,
    description: 'Workhorse 2.5-ton truck - backbone of US logistics',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.M3_HALFTRACK]: {
    name: 'M3 Halftrack',
    movement: 5,
    attack: 2,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 14,
    description: 'Armored personnel carrier with .50 cal MG',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  },
  [UnitType.DUKW_AMPHIBIOUS]: {
    name: 'DUKW Duck',
    movement: 6,
    attack: 0,
    defense: 1,
    maxHealth: 13,
    range: 0,
    cost: 8,
    description: 'Amphibious truck - essential for island hopping',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.LVT_4_AMTRAC]: {
    name: 'LVT(A)-4 Amtrac',
    movement: 5,
    attack: 3,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 16,
    description: 'Armored amphibious tractor with .50 cal turret',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  },
  
  // Ground Transport Vehicles - German
  [UnitType.OPEL_BLITZ]: {
    name: 'Opel Blitz',
    movement: 6,
    attack: 0,
    defense: 1,
    maxHealth: 12,
    range: 0,
    cost: 6,
    description: 'Standard Wehrmacht 3-ton truck - reliable workhorse',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.SDKFZ_251]: {
    name: 'Sd.Kfz. 251',
    movement: 5,
    attack: 3,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 15,
    description: 'Hanomag halftrack with MG42 - Panzergrenadier carrier',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  },
  [UnitType.STEYR_1500A]: {
    name: 'Steyr 1500A',
    movement: 6,
    attack: 0,
    defense: 1,
    maxHealth: 11,
    range: 0,
    cost: 6,
    description: 'Austrian truck adapted for desert - reliable in sand',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.SDKFZ_251_AFRIKA]: {
    name: 'Sd.Kfz. 251 Afrika',
    movement: 5,
    attack: 3,
    defense: 3,
    maxHealth: 19,
    range: 2,
    cost: 15,
    description: 'Desert-modified Hanomag with MG34 - Afrika Korps standard',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  },
  
  // Ground Transport Vehicles - Soviet
  [UnitType.ZIS_5]: {
    name: 'ZiS-5',
    movement: 6,
    attack: 0,
    defense: 1,
    maxHealth: 10,
    range: 0,
    cost: 5,
    description: 'Rugged 3-ton truck - "Zakhar" survived everything',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.M3A1_SCOUT_CAR]: {
    name: 'M3A1 Scout Car',
    movement: 5,
    attack: 2,
    defense: 2,
    maxHealth: 16,
    range: 2,
    cost: 12,
    description: 'Lend-lease armored car with DShK machine gun',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  },
  
  // Ground Transport Vehicles - British
  [UnitType.BEDFORD_OYD]: {
    name: 'Bedford OYD',
    movement: 6,
    attack: 0,
    defense: 1,
    maxHealth: 12,
    range: 0,
    cost: 7,
    description: '3-ton lorry - carried the 8th Army across Africa',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.LOYD_CARRIER]: {
    name: 'Loyd Carrier',
    movement: 5,
    attack: 2,
    defense: 3,
    maxHealth: 17,
    range: 2,
    cost: 13,
    description: 'Tracked carrier - larger than Universal, well-armored',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  },
  
  // Ground Transport Vehicles - Japanese
  [UnitType.ISUZU_TYPE_94]: {
    name: 'Isuzu Type 94',
    movement: 6,
    attack: 0,
    defense: 1,
    maxHealth: 10,
    range: 0,
    cost: 5,
    description: '6-wheel truck - adapted for jungle conditions',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.TYPE_1_HO_HA]: {
    name: 'Type 1 Ho-Ha',
    movement: 5,
    attack: 2,
    defense: 2,
    maxHealth: 15,
    range: 2,
    cost: 11,
    description: 'Rare halftrack with Type 96 MG - late war production',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  },
  
  // Ground Transport Vehicles - Canadian
  [UnitType.CMP_TRUCK]: {
    name: 'CMP 3-ton',
    movement: 6,
    attack: 0,
    defense: 1,
    maxHealth: 14,
    range: 0,
    cost: 7,
    description: 'Canadian Military Pattern truck - built for all theaters',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.PRIEST_KANGAROO]: {
    name: 'Priest Kangaroo',
    movement: 5,
    attack: 2,
    defense: 4,
    maxHealth: 24,
    range: 2,
    cost: 17,
    description: 'Converted M7 Priest SPG - turret removed for troops',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  },
  
  // Ground Transport Vehicles - Italian
  [UnitType.FIAT_626]: {
    name: 'Fiat 626',
    movement: 6,
    attack: 0,
    defense: 1,
    maxHealth: 11,
    range: 0,
    cost: 6,
    description: 'Medium truck - served from Ethiopia to Russia',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.FIAT_SPA_DOVUNQUE]: {
    name: 'Fiat SPA Dovunque',
    movement: 5,
    attack: 2,
    defense: 2,
    maxHealth: 17,
    range: 2,
    cost: 13,
    description: 'Protected truck with Breda MG - "Everywhere" all-terrain',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  },
  
  // France 1940 Units
  [UnitType.FRENCH_INFANTRY_SQUAD]: {
    name: 'French Infantry Squad',
    movement: 3,
    attack: 4,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 10,
    description: '12 soldiers: Sergeant with MAS-38, Corporal with MAS-36, 6 Riflemen with MAS-36 rifles, 2 Machine gunners with FM 24/29, 2 Grenadiers with rifle grenades',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.CHASSEURS_ALPINS]: {
    name: 'Chasseurs Alpins',
    movement: 4,
    attack: 5,
    defense: 4,
    maxHealth: 22,
    range: 2,
    cost: 15,
    description: '10 elite mountain troops: Lieutenant with pistol, 2 Sergeants with MAS-38, 5 Chasseurs with MAS-36 rifles, 2 Machine gunners with FM 24/29',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.FOREIGN_LEGION_SQUAD]: {
    name: 'Foreign Legion Squad',
    movement: 3,
    attack: 6,
    defense: 5,
    maxHealth: 20,
    range: 2,
    cost: 18,
    description: '11 legionnaires: Adjudant-chef with MAS-38, 2 Sergeants with MAS-36, 6 Legionnaires with Lebel rifles, 2 Machine gunners with FM 24/29',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 4
  },
  [UnitType.COLONIAL_TROOPS]: {
    name: 'Colonial Troops',
    movement: 3,
    attack: 5,
    defense: 4,
    maxHealth: 22,
    range: 2,
    cost: 14,
    description: 'Elite colonial troops: French NCO with MAS-38, 2 Corporals, 7 Tirailleurs with MAS-36, 2 FM 24/29 teams, combat veterans from Africa',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.FRENCH_ENGINEERS]: {
    name: 'Sapeurs',
    movement: 3,
    attack: 3,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 12,
    description: '8 combat engineers: Lieutenant engineer with pistol, Sergeant with MAS-38, 4 Sappers with rifles and explosives, 2 Specialists with flamethrowers',
    trainingTime: 2,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.FRENCH_MEDICAL_CORPS]: {
    name: 'Service de Santé',
    movement: 3,
    attack: 1,
    defense: 2,
    maxHealth: 15,
    range: 1,
    cost: 8,
    description: '6 medical personnel: Medical officer, 2 Nurses, 3 Stretcher bearers with basic weapons',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.CHAR_B1_BIS]: {
    name: 'Char B1 Bis',
    movement: 3,
    attack: 9,
    defense: 8,
    maxHealth: 35,
    range: 3,
    cost: 25,
    description: '4 crew: Commander, Driver, Gunner for 75mm howitzer, Loader/radio operator with 47mm turret gun',
    trainingTime: 3,
    category: UnitCategory.ARMOR,
    level: 4
  },
  [UnitType.SOMUA_S35]: {
    name: 'SOMUA S35',
    movement: 5,
    attack: 7,
    defense: 6,
    maxHealth: 28,
    range: 3,
    cost: 20,
    description: '3 crew: Commander/gunner with 47mm SA35, Driver, Radio operator',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 3
  },
  [UnitType.HOTCHKISS_H39]: {
    name: 'Hotchkiss H39',
    movement: 4,
    attack: 5,
    defense: 5,
    maxHealth: 22,
    range: 2,
    cost: 15,
    description: '2 crew: Commander/gunner with 37mm SA38, Driver',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.CANON_75MM]: {
    name: 'Canon de 75',
    movement: 2,
    attack: 8,
    defense: 2,
    maxHealth: 16,
    range: 5,
    cost: 14,
    description: '6 crew operating the famous French 75mm field gun',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 2
  },
  [UnitType.CANON_47MM_AT]: {
    name: 'Canon de 47 antichar',
    movement: 2,
    attack: 7,
    defense: 2,
    maxHealth: 14,
    range: 3,
    cost: 12,
    description: '4 crew with 47mm SA37 anti-tank gun',
    trainingTime: 1,
    category: UnitCategory.ARTILLERY,
    level: 2
  },
  [UnitType.FRENCH_RECON]: {
    name: 'AMD Panhard 178',
    movement: 6,
    attack: 3,
    defense: 2,
    maxHealth: 15,
    range: 2,
    cost: 10,
    description: 'Panhard 178 armored car with 4 crew',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 2
  },
  [UnitType.MS_406_FIGHTER]: {
    name: 'MS.406 Fighter',
    movement: 8,
    attack: 4,
    defense: 3,
    maxHealth: 15,
    range: 4,
    cost: 18,
    description: 'Morane-Saulnier fighter with pilot',
    trainingTime: 2,
    category: UnitCategory.FIGHTERS,
    level: 2
  },
  [UnitType.POTEZ_63_BOMBER]: {
    name: 'Potez 63',
    movement: 7,
    attack: 9,
    defense: 2,
    maxHealth: 11,
    range: 1,
    cost: 20,
    description: 'Twin-engine bomber with 3 crew',
    trainingTime: 3,
    category: UnitCategory.BOMBERS,
    level: 2
  },
  [UnitType.RENAULT_AHS]: {
    name: 'Renault AHS',
    movement: 5,
    attack: 1,
    defense: 1,
    maxHealth: 14,
    range: 1,
    cost: 8,
    description: 'Transport truck with driver and assistant',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.LORRAINE_38L]: {
    name: 'Lorraine 38L',
    movement: 4,
    attack: 2,
    defense: 3,
    maxHealth: 16,
    range: 1,
    cost: 11,
    description: 'Armored supply carrier with 2 crew',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 2
  },
  
  // Wehrmacht 1940 Units
  [UnitType.WEHRMACHT_INFANTRY_1940]: {
    name: 'Wehrmacht Infantry',
    movement: 3,
    attack: 5,
    defense: 3,
    maxHealth: 21,
    range: 2,
    cost: 11,
    description: '12 soldiers: Unteroffizier with MP38, 2 Obergefreiters with rifles, 7 Schutzen with Kar98k, 2 MG34 gunners with assistants',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.STOSSTRUPPEN_1940]: {
    name: 'Stoßtruppen',
    movement: 4,
    attack: 6,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 16,
    description: '10 assault troops: Feldwebel with MP38, 3 Unteroffiziers with MP38, 4 Stosstruppen with grenades and rifles, 2 MG34 teams',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.GEBIRGSJAGER_1940]: {
    name: 'Gebirgsjäger',
    movement: 4,
    attack: 5,
    defense: 4,
    maxHealth: 22,
    range: 2,
    cost: 14,
    description: '11 mountain troops: Oberjager with MP40, 2 Jagers with scoped rifles, 6 Gebirgsjagers with Kar98k, 2 MG34 gunners',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 3
  },
  [UnitType.MOTORIZED_INFANTRY_1940]: {
    name: 'Panzergrenadiers',
    movement: 3,
    attack: 6,
    defense: 4,
    maxHealth: 20,
    range: 2,
    cost: 18,
    description: 'Elite mechanized infantry: Squad leader with MP40, 2 MG42 teams, 6 grenadiers with Kar98k and Panzerfausts',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.PIONIERE_1940]: {
    name: 'Pioniere',
    movement: 3,
    attack: 4,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 13,
    description: '9 combat engineers: Pioneer Feldwebel with MP38, 2 Unteroffiziers with rifles, 4 Pioneers with explosives, 2 Flamethrower operators',
    trainingTime: 2,
    category: UnitCategory.ENGINEERS,
    level: 2
  },
  [UnitType.SANITATER_1940]: {
    name: 'Sanitäter',
    movement: 3,
    attack: 1,
    defense: 2,
    maxHealth: 15,
    range: 1,
    cost: 8,
    description: '5 medical personnel: Sanitatsoffizier, 2 Sanitaters, 2 Stretcher bearers',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.PANZER_III_E]: {
    name: 'Panzer III Ausf.E',
    movement: 5,
    attack: 6,
    defense: 5,
    maxHealth: 25,
    range: 3,
    cost: 18,
    description: '5 crew: Commander, Gunner with 37mm KwK36, Loader, Driver, Radio operator/MG',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 3
  },
  [UnitType.PANZER_II_C]: {
    name: 'Panzer II Ausf.C',
    movement: 6,
    attack: 4,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 12,
    description: '3 crew: Commander/gunner with 20mm KwK30, Driver, Radio operator',
    trainingTime: 1,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.PANZER_38T]: {
    name: 'Panzer 38(t)',
    movement: 5,
    attack: 5,
    defense: 4,
    maxHealth: 22,
    range: 3,
    cost: 15,
    description: '4 crew: Commander, Gunner with 37mm, Loader/radio operator, Driver',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.STUG_III_A]: {
    name: 'StuG III Ausf.A',
    movement: 4,
    attack: 7,
    defense: 5,
    maxHealth: 24,
    range: 3,
    cost: 16,
    description: '4 crew with 75mm StuK37 L/24 howitzer',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.PAK_36_BATTERY]: {
    name: 'PaK 36 Battery',
    movement: 2,
    attack: 5,
    defense: 2,
    maxHealth: 14,
    range: 3,
    cost: 10,
    description: '5 crew with 37mm PaK36 anti-tank gun',
    trainingTime: 1,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.AUFKLARUNG_1940]: {
    name: 'Sd.Kfz. 222',
    movement: 7,
    attack: 3,
    defense: 2,
    maxHealth: 14,
    range: 2,
    cost: 11,
    description: 'Light armored reconnaissance vehicle with 3 crew: Commander, gunner with 20mm autocannon, driver',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 2
  },
  [UnitType.BF_109E_FIGHTER]: {
    name: 'Bf 109E',
    movement: 9,
    attack: 5,
    defense: 4,
    maxHealth: 16,
    range: 4,
    cost: 20,
    description: 'Messerschmitt fighter with pilot',
    trainingTime: 2,
    category: UnitCategory.FIGHTERS,
    level: 3
  },
  [UnitType.JU_87B_STUKA]: {
    name: 'Ju 87B Stuka',
    movement: 6,
    attack: 10,
    defense: 2,
    maxHealth: 12,
    range: 1,
    cost: 22,
    description: 'Dive bomber with pilot and rear gunner',
    trainingTime: 3,
    category: UnitCategory.BOMBERS,
    level: 3
  },
  [UnitType.OPEL_BLITZ_1940]: {
    name: 'Opel Blitz',
    movement: 5,
    attack: 0,
    defense: 1,
    maxHealth: 14,
    range: 1,
    cost: 8,
    description: '3-ton truck with driver and assistant',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.SDKFZ_251_AUSF_A]: {
    name: 'SdKfz 251 Ausf.A',
    movement: 5,
    attack: 3,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 14,
    description: 'Halftrack with 2 crew and MG34',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 2
  },
  
  // Italian 1940 Units
  [UnitType.REGULAR_INFANTRY_1940]: {
    name: 'Regular Infantry',
    movement: 3,
    attack: 3,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 7,
    description: 'Poorly trained conscripts with outdated equipment',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.ALPINI_1940]: {
    name: 'Alpini',
    movement: 4,
    attack: 5,
    defense: 5,
    maxHealth: 22,
    range: 2,
    cost: 11,
    description: 'Elite mountain warfare specialists',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.BLACKSHIRT_BATTALION]: {
    name: 'Blackshirt Battalion',
    movement: 3,
    attack: 4,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 8,
    description: 'Fascist militia - brave but tactically poor',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.LIBYAN_COLONIAL_TROOPS]: {
    name: 'Libyan Colonial',
    movement: 3,
    attack: 3,
    defense: 2,
    maxHealth: 16,
    range: 2,
    cost: 5,
    description: 'Colonial forces from Italian North Africa',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.GENIO_SAPPERS_1940]: {
    name: 'Genio Sappers',
    movement: 3,
    attack: 4,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 10,
    description: 'Combat engineers for mountain warfare',
    trainingTime: 1,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.REGIO_MEDICI]: {
    name: 'Regio Medici',
    movement: 3,
    attack: 0,
    defense: 1,
    maxHealth: 10,
    range: 1,
    cost: 8,
    description: 'Royal Army medical corps',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.L3_33_TANKETTE]: {
    name: 'L3/33 Tankette',
    movement: 5,
    attack: 3,
    defense: 2,
    maxHealth: 14,
    range: 2,
    cost: 12,
    description: 'Obsolete CV33 tankette - death trap',
    trainingTime: 1,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.M11_39_TANK]: {
    name: 'M11/39',
    movement: 4,
    attack: 5,
    defense: 4,
    maxHealth: 22,
    range: 3,
    cost: 18,
    description: 'Medium tank with hull-mounted gun',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.L6_40_LIGHT_TANK]: {
    name: 'L6/40',
    movement: 6,
    attack: 4,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 14,
    description: 'Light reconnaissance tank',
    trainingTime: 1,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.CANNONE_47_32]: {
    name: 'Cannone 47/32',
    movement: 2,
    attack: 6,
    defense: 2,
    maxHealth: 12,
    range: 3,
    cost: 12,
    description: 'Anti-tank gun, barely adequate',
    trainingTime: 1,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.OBICE_100_17]: {
    name: 'Obice 100/17',
    movement: 2,
    attack: 7,
    defense: 1,
    maxHealth: 10,
    range: 4,
    cost: 16,
    description: 'Pack howitzer for mountain warfare',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 2
  },
  [UnitType.AB_40_ARMORED_CAR]: {
    name: 'AB 40',
    movement: 8,
    attack: 3,
    defense: 2,
    maxHealth: 14,
    range: 2,
    cost: 10,
    description: 'Autoblinda reconnaissance vehicle',
    trainingTime: 1,
    category: UnitCategory.RECONNAISSANCE,
    level: 1
  },
  [UnitType.CR_42_FALCO]: {
    name: 'CR.42 Falco',
    movement: 12,
    attack: 4,
    defense: 3,
    maxHealth: 14,
    range: 2,
    cost: 18,
    description: 'Last biplane fighter - completely obsolete',
    trainingTime: 2,
    category: UnitCategory.FIGHTERS,
    level: 2
  },
  [UnitType.SM_79_SPARVIERO]: {
    name: 'SM.79 Sparviero',
    movement: 10,
    attack: 8,
    defense: 3,
    maxHealth: 20,
    range: 2,
    cost: 26,
    description: 'Tri-motor bomber - Italy\'s best aircraft',
    trainingTime: 3,
    category: UnitCategory.BOMBERS,
    level: 3
  },
  [UnitType.FIAT_SPA_AUTOPROTETTO]: {
    name: 'Fiat-SPA Autoprotetto',
    movement: 5,
    attack: 2,
    defense: 3,
    maxHealth: 16,
    range: 2,
    cost: 14,
    description: 'Armored truck for protected transport',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  },
  
  // Greek 1940 Units
  [UnitType.EVZONES_REGIMENT]: {
    name: 'Evzones Regiment',
    movement: 4,
    attack: 5,
    defense: 6,
    maxHealth: 24,
    range: 2,
    cost: 12,
    description: 'Elite mountain warriors in traditional uniform',
    trainingTime: 2,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.REGULAR_INFANTRY_DIVISION]: {
    name: 'Infantry Division',
    movement: 3,
    attack: 4,
    defense: 4,
    maxHealth: 20,
    range: 2,
    cost: 8,
    description: 'Well-motivated Greek conscripts',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.CRETAN_DIVISION]: {
    name: 'Cretan Division',
    movement: 3,
    attack: 5,
    defense: 4,
    maxHealth: 22,
    range: 2,
    cost: 10,
    description: 'Legendary Cretan fighters',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 2
  },
  [UnitType.NATIONAL_GUARD_BATTALION]: {
    name: 'National Guard',
    movement: 3,
    attack: 3,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 6,
    description: 'Older reservists with WWI equipment',
    trainingTime: 1,
    category: UnitCategory.INFANTRY,
    level: 1
  },
  [UnitType.ENGINEER_COMPANY]: {
    name: 'Engineer Company',
    movement: 3,
    attack: 3,
    defense: 3,
    maxHealth: 18,
    range: 1,
    cost: 10,
    description: 'Combat engineers for mountain fortifications',
    trainingTime: 1,
    category: UnitCategory.ENGINEERS,
    level: 1
  },
  [UnitType.MEDICAL_SECTION]: {
    name: 'Medical Section',
    movement: 3,
    attack: 0,
    defense: 1,
    maxHealth: 10,
    range: 1,
    cost: 8,
    description: 'Small but dedicated medical service',
    trainingTime: 1,
    category: UnitCategory.MEDICS,
    level: 1
  },
  [UnitType.VICKERS_6TON_TANK]: {
    name: 'Vickers 6-Ton',
    movement: 5,
    attack: 5,
    defense: 4,
    maxHealth: 20,
    range: 3,
    cost: 16,
    description: 'British light tank - Greece\'s best armor',
    trainingTime: 2,
    category: UnitCategory.ARMOR,
    level: 2
  },
  [UnitType.FT_17_RENAULT]: {
    name: 'FT-17 Renault',
    movement: 3,
    attack: 4,
    defense: 3,
    maxHealth: 16,
    range: 2,
    cost: 12,
    description: 'Ancient WWI tank - slow but functional',
    trainingTime: 1,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.CARDEN_LOYD_TANKETTE]: {
    name: 'Carden Loyd',
    movement: 6,
    attack: 3,
    defense: 2,
    maxHealth: 12,
    range: 2,
    cost: 10,
    description: 'British tankette for reconnaissance',
    trainingTime: 1,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.CAPTURED_L3_TANKETTE]: {
    name: 'Captured L3',
    movement: 5,
    attack: 3,
    defense: 2,
    maxHealth: 14,
    range: 2,
    cost: 8,
    description: 'Italian tankette turned against former owners',
    trainingTime: 1,
    category: UnitCategory.ARMOR,
    level: 1
  },
  [UnitType.SCHNEIDER_75MM_MOUNTAIN_GUN]: {
    name: 'Schneider 75mm',
    movement: 2,
    attack: 7,
    defense: 1,
    maxHealth: 10,
    range: 4,
    cost: 14,
    description: 'French mountain gun ideal for Greek terrain',
    trainingTime: 2,
    category: UnitCategory.ARTILLERY,
    level: 2
  },
  [UnitType.SKODA_75MM_FIELD_GUN]: {
    name: 'Škoda 75mm',
    movement: 2,
    attack: 6,
    defense: 1,
    maxHealth: 10,
    range: 3,
    cost: 12,
    description: 'Czech field artillery, reliable and effective',
    trainingTime: 1,
    category: UnitCategory.ARTILLERY,
    level: 1
  },
  [UnitType.PZL_P24_FIGHTER]: {
    name: 'PZL P.24',
    movement: 14,
    attack: 6,
    defense: 4,
    maxHealth: 16,
    range: 2,
    cost: 20,
    description: 'Polish fighter - Greece\'s most modern aircraft',
    trainingTime: 2,
    category: UnitCategory.FIGHTERS,
    level: 2
  },
  [UnitType.FAIREY_BATTLE_BOMBER]: {
    name: 'Fairey Battle',
    movement: 10,
    attack: 7,
    defense: 3,
    maxHealth: 18,
    range: 2,
    cost: 24,
    description: 'British light bomber - obsolete but serviceable',
    trainingTime: 3,
    category: UnitCategory.BOMBERS,
    level: 3
  },
  [UnitType.FORD_V8_TRUCK]: {
    name: 'Ford V8 Truck',
    movement: 6,
    attack: 0,
    defense: 1,
    maxHealth: 10,
    range: 1,
    cost: 8,
    description: 'American trucks assembled in Greece',
    trainingTime: 1,
    category: UnitCategory.TRANSPORT,
    level: 1
  },
  [UnitType.DODGE_T110L_HALFTRACK]: {
    name: 'Dodge T-110L',
    movement: 5,
    attack: 2,
    defense: 3,
    maxHealth: 16,
    range: 2,
    cost: 14,
    description: 'American halftrack - Greece\'s best transport',
    trainingTime: 1,
    category: UnitCategory.HALFTRACK,
    level: 1
  }
};

// Map airborne units to their transport aircraft
export function getTransportForAirborne(airborneType: UnitType): UnitType | null {
  switch(airborneType) {
    case UnitType.AIRBORNE_SQUAD:
      return UnitType.C47_SKYTRAIN;
    case UnitType.MARINE_PARACHUTE_REGIMENT:
      return UnitType.R4D_SKYTRAIN;
    case UnitType.RED_DEVILS_PARACHUTE:
      return UnitType.STIRLING_TRANSPORT;
    case UnitType.VDV_GUARDS_AIRBORNE:
      return UnitType.LI2_TRANSPORT;
    case UnitType.FALLSCHIRMJAGER_SQUAD:
      return UnitType.JU52_TRANSPORT;
    case UnitType.AK_FALLSCHIRMJAGER:
      return UnitType.JU52_AFRIKA;
    case UnitType.CANADIAN_PARACHUTE_BATTALION:
      return UnitType.DAKOTA_TRANSPORT;
    case UnitType.FOLGORE_PARATROOPERS:
      return UnitType.SM82_MARSUPIALE;
    case UnitType.TEISHIN_SHUDAN:
      return UnitType.KI57_TRANSPORT;
    default:
      return null;
  }
}

// Check if a unit is an airborne unit
export function isAirborneUnit(unitType: UnitType): boolean {
  return [
    UnitType.AIRBORNE_SQUAD,
    UnitType.MARINE_PARACHUTE_REGIMENT,
    UnitType.RED_DEVILS_PARACHUTE,
    UnitType.VDV_GUARDS_AIRBORNE,
    UnitType.FALLSCHIRMJAGER_SQUAD,
    UnitType.FALLSCHIRMJAGER_SQUAD_1942,
    UnitType.AK_FALLSCHIRMJAGER,
    UnitType.CANADIAN_PARACHUTE_BATTALION,
    UnitType.FOLGORE_PARATROOPERS,
    UnitType.TEISHIN_SHUDAN
  ].includes(unitType);
}

// Check if a unit is a transport aircraft
export function isTransportAircraft(unitType: UnitType): boolean {
  const unit = UNIT_DEFINITIONS[unitType];
  return unit && unit.category === UnitCategory.TRANSPORT_AIRCRAFT;
}

// Check if a unit is a fighter aircraft
export function isFighter(unitType: UnitType): boolean {
  const unit = UNIT_DEFINITIONS[unitType];
  return unit && unit.category === UnitCategory.FIGHTERS;
}

// Check if a unit is a bomber aircraft
export function isBomber(unitType: UnitType): boolean {
  const unit = UNIT_DEFINITIONS[unitType];
  return unit && unit.category === UnitCategory.BOMBERS;
}

// Check if a unit is any type of aircraft
export function isAircraft(unitType: UnitType): boolean {
  const unit = UNIT_DEFINITIONS[unitType];
  return unit && (unit.category === UnitCategory.FIGHTERS || 
                  unit.category === UnitCategory.BOMBERS || 
                  unit.category === UnitCategory.TRANSPORT_AIRCRAFT);
}

// Check if a unit is a ground transport vehicle (truck or halftrack)
export function isGroundTransport(unitType: UnitType): boolean {
  return [
    // Trucks
    UnitType.GMC_CCKW,
    UnitType.OPEL_BLITZ,
    UnitType.OPEL_BLITZ_1940,
    UnitType.OPEL_BLITZ_1942,
    UnitType.STEYR_1500A,
    UnitType.ZIS_5,
    UnitType.BEDFORD_OYD,
    UnitType.ISUZU_TYPE_94,
    UnitType.CMP_TRUCK,
    UnitType.FIAT_626,
    UnitType.DUKW_AMPHIBIOUS,
    // Halftracks and armored transports
    UnitType.M3_HALFTRACK,
    UnitType.SDKFZ_251,
    UnitType.SDKFZ_251_AUSF_A,
    UnitType.SDKFZ_251_1942,
    UnitType.SDKFZ_251_AFRIKA,
    UnitType.M3A1_SCOUT_CAR,
    UnitType.LOYD_CARRIER,
    UnitType.TYPE_1_HO_HA,
    UnitType.PRIEST_KANGAROO,
    UnitType.FIAT_SPA_DOVUNQUE,
    UnitType.LVT_4_AMTRAC
  ].includes(unitType);
}

// Check if a unit can be transported by ground vehicles
export function canBeTransported(unitType: UnitType): boolean {
  const unit = UNIT_DEFINITIONS[unitType];
  return unit && (
    unit.category === UnitCategory.INFANTRY ||
    unit.category === UnitCategory.ENGINEERS ||
    unit.category === UnitCategory.MEDICS
  );
}

// Check if a unit is a truck (unarmored transport)
export function isTruck(unitType: UnitType): boolean {
  const unit = UNIT_DEFINITIONS[unitType];
  return unit && unit.category === UnitCategory.TRANSPORT;
}

// Check if a unit is an armored transport/halftrack
export function isArmoredTransport(unitType: UnitType): boolean {
  const unit = UNIT_DEFINITIONS[unitType];
  return unit && unit.category === UnitCategory.HALFTRACK;
}

// Get units available for a faction
export function getUnitsForFaction(faction: 'United States Of America' | '3rd Reich' | 'United Kingdom' | 'USSR' | 'Imperial Japan' | 'Canada' | 'Fascist Italy' | 'France' | 'Greece', campaign?: 'normandy' | 'tunisia' | 'stalingrad' | 'okinawa' | 'campobasso' | 'tutorial' | 'france_1940' | 'albania_1940'): UnitType[] {
  if (faction === 'United States Of America') {
    if (campaign === 'okinawa') {
      // US Marines units for Okinawa
      return [
        UnitType.MARINE_SQUAD,
        UnitType.MARINE_RAIDERS,
        UnitType.MARINE_FLAME_TEAM,
        UnitType.MARINE_ENGINEERS,
        UnitType.NAVY_CORPSMEN,
        UnitType.MARINE_PARACHUTE_REGIMENT,
        UnitType.M4A3_SHERMAN,
        UnitType.M3_STUART,
        UnitType.M7_PRIEST,
        UnitType.PACK_HOWITZER,
        UnitType.P51_MUSTANG,
        UnitType.B24_LIBERATOR,
        UnitType.LVT_4_AMTRAC,
        UnitType.DUKW_AMPHIBIOUS
      ];
    } else {
      // Regular US Army units for Normandy
      return [
        UnitType.RIFLE_SQUAD,
        UnitType.RANGER_SQUAD,
        UnitType.AIRBORNE_SQUAD,
        UnitType.HEAVY_WEAPONS_SQUAD,
        UnitType.SHERMAN_SECTION,
        UnitType.TANK_DESTROYER_SECTION,
        UnitType.US_ARTILLERY_SECTION,
        UnitType.ENGINEER_SQUAD,
        UnitType.MEDICAL_CORPS_SQUAD,
        UnitType.M8_GREYHOUND,
        UnitType.P51_MUSTANG,
        UnitType.B24_LIBERATOR,
        UnitType.GMC_CCKW,
        UnitType.M3_HALFTRACK
      ];
    }
  } else if (faction === 'United Kingdom') {
    return [
      UnitType.INFANTRY_SECTION,
      UnitType.GUARDS_INFANTRY,
      UnitType.COMMANDO_SECTION,
      UnitType.RED_DEVILS_PARACHUTE,
      UnitType.SAPPER_SECTION,
      UnitType.FIELD_AMBULANCE_SECTION,
      UnitType.CRUSADER_TANK,
      UnitType.MATILDA_II,
      UnitType.SIX_POUNDER_AT,
      UnitType.TWENTY_FIVE_POUNDER,
      UnitType.DAIMLER_DINGO,
      UnitType.SPITFIRE_MK_V,
      UnitType.LANCASTER_BOMBER,
      UnitType.BEDFORD_OYD,
      UnitType.LOYD_CARRIER
    ];
  } else if (faction === 'USSR') {
    return [
      UnitType.CONSCRIPT_SQUAD,
      UnitType.RED_ARMY_SQUAD,
      UnitType.SHOCK_TROOPS,
      UnitType.VDV_GUARDS_AIRBORNE,
      UnitType.T70_LIGHT_TANK,
      UnitType.T34_76,
      UnitType.KV1_HEAVY_TANK,
      UnitType.BA64_ARMORED_CAR,
      UnitType.ZIS3_AT_GUN,
      UnitType.KATYUSHA_BATTERY,
      UnitType.SOVIET_SAPPER_SQUAD,
      UnitType.MEDICAL_BATTALION,
      UnitType.YAK_3_FIGHTER,
      UnitType.IL2_STURMOVIK,
      UnitType.ZIS_5,
      UnitType.M3A1_SCOUT_CAR
    ];
  } else if (faction === '3rd Reich') {
    // 3rd Reich - different units for different campaigns
    if (campaign === 'tunisia') {
      return [
        UnitType.SCHUTZEN_SQUAD,
        UnitType.AFRIKA_GRENADIERS,
        UnitType.AK_PIONEER_SQUAD,
        UnitType.AK_SANITATER,
        UnitType.AK_FALLSCHIRMJAGER,
        UnitType.BRANDENBURG_COMMANDOS,
        UnitType.PANZER_III,
        UnitType.PANZER_II,
        UnitType.EIGHTY_EIGHT_FLAK,
        UnitType.PAK_38,
        UnitType.SDKFZ_250_9,
        UnitType.BF109_FIGHTER,
        UnitType.JU88_BOMBER,
        UnitType.STEYR_1500A,
        UnitType.SDKFZ_251_AFRIKA
      ];
    } else if (campaign === 'stalingrad') {
      // Stalingrad units - Eastern Wehrmacht 1942
      return [
        UnitType.GRENADIER_SQUAD_1942,
        UnitType.STURM_ABTEILUNG_SQUAD,
        UnitType.FALLSCHIRMJAGER_SQUAD_1942,
        UnitType.PANZERGRENADIER_SQUAD_1942,
        UnitType.STURMPIONIERE,
        UnitType.SANITATER_SQUAD_1942,
        UnitType.PANZER_IV_AUSF_F2,
        UnitType.PANZER_III_AUSF_L,
        UnitType.STUG_III_AUSF_F,
        UnitType.PAK_38_BATTERY,
        UnitType.SDKFZ_250_1,
        UnitType.JU_87_D_STUKA,
        UnitType.HE_111_H6,
        UnitType.OPEL_BLITZ_1942,
        UnitType.SDKFZ_251_1942
      ];
    } else if (campaign === 'france_1940') {
      // Wehrmacht units for Battle of France 1940
      return [
        UnitType.WEHRMACHT_INFANTRY_1940,
        UnitType.STOSSTRUPPEN_1940,
        UnitType.GEBIRGSJAGER_1940,
        UnitType.MOTORIZED_INFANTRY_1940,
        UnitType.PIONIERE_1940,
        UnitType.SANITATER_1940,
        UnitType.PANZER_III_E,
        UnitType.PANZER_II_C,
        UnitType.PANZER_38T,
        UnitType.STUG_III_A,
        UnitType.PAK_36_BATTERY,
        UnitType.AUFKLARUNG_1940,
        UnitType.BF_109E_FIGHTER,
        UnitType.JU_87B_STUKA,
        UnitType.OPEL_BLITZ_1940,
        UnitType.SDKFZ_251_AUSF_A
      ];
    } else {
      // Normandy units - Western Wehrmacht 1944
      return [
        UnitType.PANZERGRENADIER_SQUAD,
        UnitType.WAFFEN_SS_SQUAD,
        UnitType.FALLSCHIRMJAGER_SQUAD,
        UnitType.GEBIRGSJAGER_SQUAD,
        UnitType.PANZER_IV_ZUG,
        UnitType.TIGER_I_SECTION,
        UnitType.STUG_III_SECTION,
        UnitType.GER_ARTILLERY_SECTION,
        UnitType.PIONEER_SQUAD,
        UnitType.SANITATER_SQUAD,
        UnitType.SDKFZ_222,
        UnitType.BF109_FIGHTER,
        UnitType.JU88_BOMBER,
        UnitType.OPEL_BLITZ,
        UnitType.SDKFZ_251
      ];
    }
  } else if (faction === 'Imperial Japan') {
    // Imperial Japan units for Okinawa
    return [
      UnitType.IJA_SQUAD,
      UnitType.SNLF_SQUAD,
      UnitType.ASSAULT_PIONEERS,
      UnitType.IJA_MEDICAL_CORPS,
      UnitType.CAVE_DEFENSE_SQUAD,
      UnitType.TEISHIN_SHUDAN,
      UnitType.TYPE_95_HA_GO,
      UnitType.TYPE_97_CHI_HA,
      UnitType.TYPE_4_CHI_TO,
      UnitType.TYPE_92_JYU_SOKOSHA,
      UnitType.TYPE_92_BATTALION_GUN,
      UnitType.TYPE_89_MORTAR,
      UnitType.TYPE_1_47MM_AT_GUN,
      UnitType.TYPE_96_150MM_HOWITZER,
      UnitType.A6M_ZERO,
      UnitType.G4M_BETTY,
      UnitType.ISUZU_TYPE_94,
      UnitType.TYPE_1_HO_HA
    ];
  } else if (faction === 'Canada') {
    // Canadian units for Campobasso
    return [
      UnitType.CANADIAN_INFANTRY_SECTION,
      UnitType.PPCLI,
      UnitType.HIGHLAND_REGIMENT,
      UnitType.CANADIAN_PARACHUTE_BATTALION,
      UnitType.COMBAT_ENGINEERS,
      UnitType.MEDICAL_SERVICE_CORPS,
      UnitType.RAM_TANK,
      UnitType.GRIZZLY_CRUISER,
      UnitType.SEXTON_SPG,
      UnitType.TWENTY_FIVE_POUNDER_BATTERY,
      UnitType.RECONNAISSANCE_PATROL,
      UnitType.SHERMAN_FIREFLY,
      UnitType.SPITFIRE_FIGHTER,
      UnitType.MOSQUITO_FIGHTER_BOMBER,
      UnitType.CMP_TRUCK,
      UnitType.PRIEST_KANGAROO
    ];
  } else if (faction === 'Fascist Italy') {
    if (campaign === 'albania_1940') {
      // Italian units for Albania 1940
      return [
        UnitType.REGULAR_INFANTRY_1940,
        UnitType.ALPINI_1940,
        UnitType.BLACKSHIRT_BATTALION,
        UnitType.LIBYAN_COLONIAL_TROOPS,
        UnitType.GENIO_SAPPERS_1940,
        UnitType.REGIO_MEDICI,
        UnitType.L3_33_TANKETTE,
        UnitType.M11_39_TANK,
        UnitType.L6_40_LIGHT_TANK,
        UnitType.CANNONE_47_32,
        UnitType.OBICE_100_17,
        UnitType.AB_40_ARMORED_CAR,
        UnitType.CR_42_FALCO,
        UnitType.SM_79_SPARVIERO,
        UnitType.FIAT_626,
        UnitType.FIAT_SPA_AUTOPROTETTO
      ];
    } else {
      // Italian units for Campobasso
      return [
        UnitType.BERSAGLIERI_SQUAD,
        UnitType.ALPINI_MOUNTAIN_TROOPS,
        UnitType.FOLGORE_PARATROOPERS,
        UnitType.SAN_MARCO_MARINES,
        UnitType.GENIO_ENGINEERS,
        UnitType.SANITA_MILITARE,
        UnitType.M15_42_TANK,
        UnitType.SEMOVENTE_75_18,
        UnitType.CANNONE_75_32,
        UnitType.OBICE_149_19,
        UnitType.ARDITI_SCOUTS,
        UnitType.P26_40_HEAVY_TANK,
        UnitType.MACCHI_C205,
        UnitType.SM79_BOMBER,
        UnitType.FIAT_626,
        UnitType.FIAT_SPA_DOVUNQUE
      ];
    }
  } else if (faction === 'France') {
    // French units for Battle of France 1940
    return [
      UnitType.FRENCH_INFANTRY_SQUAD,
      UnitType.CHASSEURS_ALPINS,
      UnitType.FOREIGN_LEGION_SQUAD,
      UnitType.COLONIAL_TROOPS,
      UnitType.FRENCH_ENGINEERS,
      UnitType.FRENCH_MEDICAL_CORPS,
      UnitType.CHAR_B1_BIS,
      UnitType.SOMUA_S35,
      UnitType.HOTCHKISS_H39,
      UnitType.CANON_75MM,
      UnitType.CANON_47MM_AT,
      UnitType.FRENCH_RECON,
      UnitType.MS_406_FIGHTER,
      UnitType.POTEZ_63_BOMBER,
      UnitType.RENAULT_AHS,
      UnitType.LORRAINE_38L
    ];
  } else if (faction === 'Greece') {
    // Greek units for Albania 1940
    return [
      UnitType.EVZONES_REGIMENT,
      UnitType.REGULAR_INFANTRY_DIVISION,
      UnitType.CRETAN_DIVISION,
      UnitType.NATIONAL_GUARD_BATTALION,
      UnitType.ENGINEER_COMPANY,
      UnitType.MEDICAL_SECTION,
      UnitType.VICKERS_6TON_TANK,
      UnitType.FT_17_RENAULT,
      UnitType.CARDEN_LOYD_TANKETTE,
      UnitType.CAPTURED_L3_TANKETTE,
      UnitType.SCHNEIDER_75MM_MOUNTAIN_GUN,
      UnitType.SKODA_75MM_FIELD_GUN,
      UnitType.PZL_P24_FIGHTER,
      UnitType.FAIREY_BATTLE_BOMBER,
      UnitType.FORD_V8_TRUCK,
      UnitType.DODGE_T110L_HALFTRACK
    ];
  }
  
  return [];
}